import { generateSingleItemQuery, generateMultiItemQuery } from '@blaze-cms/react-page-builder';
const getRenderProps = (extraProps, isPreview, data, useMultiQuery) => {
  const {
    getEntitySchema
  } = data;
  const {
    actions: {
      get,
      getPublished,
      getAll,
      getAllPublished
    }
  } = getEntitySchema;
  const queryToUse = useMultiQuery ? generateMultiItemQuery : generateSingleItemQuery;
  const singleActionKey = isPreview ? get : getPublished || get;
  const multiActionKey = isPreview ? getAll : getAllPublished || getAll;
  const actionKey = useMultiQuery ? multiActionKey : singleActionKey;
  const action = queryToUse(actionKey, extraProps);
  return {
    action,
    actionKey
  };
};
export default getRenderProps;
//# sourceMappingURL=get-render-props.js.map